import { useNavigation } from "@react-navigation/native";
import {
  TouchableBox,
  AHText,
  RoutineOccasionStatusCircleRelay,
  Box,
} from "arkh";

import React, { useCallback } from "react";
import { useFragment, graphql } from "react-relay";
import { UserLoggedInNavigatorNavigationProp } from "../../../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";

import { TeamScheduleRoutineListItemContent } from "./TeamScheduleRoutineListItemContent";
import { TeamScheduleRoutineOccasionListItem_RoutineOccasion$key } from "./__generated__/TeamScheduleRoutineOccasionListItem_RoutineOccasion.graphql";

import { TeamScheduleListItemScheduleRange } from "./TeamScheduleListItemScheduleRange/TeamScheduleListItemScheduleRange";
import { TeamScheduleRoutineOccasionListItemBadge } from "./TeamScheduleRoutineOccasionListItemBadge";

export function TeamScheduleRoutineOccasionListItem(props: {
  routineOccasion: TeamScheduleRoutineOccasionListItem_RoutineOccasion$key;
  itemType: "timeOfDay" | "allDay" | "WEEKLY" | "MONTHLY";
}) {
  const navigation =
    useNavigation<UserLoggedInNavigatorNavigationProp<"Team">>();
  const data = useFragment(
    graphql`
      fragment TeamScheduleRoutineOccasionListItem_RoutineOccasion on RoutineOccasion {
        ...RoutineOccasionStatusCircle_RoutineOccasion
        ...TeamScheduleRoutineListItemContent_RoutineOccasion
        ...TeamScheduleRoutineOccasionListItemBadgeNew_routineOccasion
        ...TeamScheduleListItemScheduleRange_routineOccasion
        sequenceNumber
        completedTaskExecutionCount
        totalTaskExecutionCount
        routine {
          id
          ...TeamScheduleRoutineListItemContent_Routine
        }
      }
    `,
    props.routineOccasion
  );

  const onPress = useCallback(() => {
    navigation.navigate("RoutineOccasion", {
      routineId: data.routine.id,
      sequenceNumber: data.sequenceNumber,
      isNotFeedOrigin: false,
    });
  }, [data.routine.id, data.sequenceNumber, navigation]);

  return (
    <TouchableBox
      spaceVertical="medium"
      spaceLeft="medium"
      onPress={onPress}
      style={{
        flex: 1,
        flexDirection: "row",
        alignItems: "center",
        height: "100%",
        justifyContent: "center",
      }}
    >
      <Box style={{ flexDirection: "column", flex: 1 }}>
        <TeamScheduleListItemScheduleRange
          routineOccasion={data}
          itemType={props.itemType}
        />
        <TeamScheduleRoutineListItemContent
          routine={data.routine}
          occasion={data}
        />
      </Box>

      <Box
        spaceHorizontal="medium"
        style={{
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        {(data.totalTaskExecutionCount ?? 0) > 0 ? (
          <>
            <Box>
              <RoutineOccasionStatusCircleRelay occasion={data} />
              <TeamScheduleRoutineOccasionListItemBadge occasion={data} />
            </Box>
            <AHText
              spaceBottom="xxsmall"
              style={{ position: "absolute", bottom: -15 }}
              numberOfLines={1}
              type="detail"
            >
              {data.completedTaskExecutionCount} /{" "}
              {data.totalTaskExecutionCount}
            </AHText>
          </>
        ) : null}
      </Box>
    </TouchableBox>
  );
}
